import React from "react";

interface ResponsiveDisplay {
  type: "image";
  content: string;
}

interface PortfolioResponsiveDisplaysProps {
  ResponsiveDisplaysData: ResponsiveDisplay[];
  primaryColor?: string;
}

interface IconProps {
  color: string;
}

const ResponsiveDisplaysIcon: React.FC<IconProps> = ({ color }) => (
  <svg
    width="40"
    height="46"
    viewBox="0 0 51 43"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0076 12.7001C13.1476 12.5531 13.3926 12.3711 13.5466 12.3011C13.8127 12.1751 14.2397 12.1681 24.314 12.1681C34.6052 12.1681 34.8082 12.1681 35.0673 12.3081C35.4103 12.4761 35.8234 12.9592 35.9144 13.2812C35.9564 13.4422 35.9844 18.4268 35.9844 27.2969C35.9844 28.3798 35.9846 29.3806 35.9848 30.3056C35.987 40.8837 35.9871 41.5553 35.6527 41.9209C35.63 41.9457 35.6058 41.969 35.5799 41.994C35.5451 42.0276 35.5073 42.0641 35.4663 42.1107C35.4259 42.1563 35.3922 42.1983 35.3612 42.237L35.3611 42.2371C35.3201 42.2882 35.2837 42.3336 35.2424 42.3739C34.914 42.6942 34.273 42.694 28.5403 42.6921C28.0657 42.692 27.5563 42.6918 27.0093 42.6918C22.8158 42.6918 19.3924 42.6778 19.3924 42.6638C19.3924 42.6498 19.5044 42.4748 19.6374 42.2717C20.0714 41.6277 20.1625 41.1796 20.1625 39.6744V38.3513L20.6385 38.3443C20.8975 38.3373 23.9569 38.3303 27.4433 38.3303L33.7791 38.3163L33.8001 26.3238L33.8141 14.3383H24.258H14.7018V16.2286V18.1188H13.6167H12.5315V15.8505C12.5315 13.3092 12.5525 13.1762 13.0076 12.7001ZM24.461 41.1516C25.3011 41.1516 25.6861 40.0175 25.035 39.4224C24.832 39.2334 24.727 39.1914 24.489 39.1914C23.7539 39.1914 23.3198 39.9055 23.6209 40.6195C23.7609 40.9556 24.0689 41.1516 24.461 41.1516ZM0.0980119 3.16499C0.406049 2.00985 1.30916 1.10674 2.4713 0.791706C2.77934 0.707695 6.16075 0.693695 25.007 0.693695C40.941 0.686691 47.2838 0.707695 47.5498 0.763702C48.8309 1.02974 49.8181 2.02385 50.0911 3.32601C50.2451 4.0331 50.2451 31.1474 50.0981 31.8545C49.8181 33.1636 48.8379 34.1578 47.5498 34.4238C47.2978 34.4728 45.5475 34.5008 42.1451 34.5008H37.1045V30.9654V27.4299L42.5512 27.4159L47.9908 27.3949V15.5285C47.9908 4.39714 47.9838 3.64805 47.8718 3.43803C47.8018 3.31901 47.6478 3.14399 47.5218 3.05298L47.2908 2.89196H25.0841H2.87735L2.68133 3.03898C2.57631 3.11599 2.41529 3.29101 2.33128 3.41702L2.17026 3.64805V15.5355V27.4299H2.97536H3.78046V30.9654V34.5008H3.33941C2.4363 34.5008 1.6242 34.1648 0.973118 33.5137C0.532065 33.0866 0.196024 32.4916 0.0770094 31.9245C0.0210026 31.6585 0 27.661 0 17.5377C0 5.90933 0.0210026 3.45903 0.0980119 3.16499ZM6.51076 19.3019C5.90168 19.491 5.37662 19.911 5.13159 20.4151L4.93557 20.8141L4.91456 30.7203C4.90056 37.5532 4.92156 40.7386 4.97057 40.9906C5.06858 41.4526 5.39762 41.9427 5.80367 42.2437C5.81108 42.2491 5.8184 42.2544 5.82562 42.2596C5.90796 42.3191 5.97895 42.3705 6.05411 42.4148C6.52465 42.6919 7.15844 42.6919 11.7602 42.6918L12.0134 42.6918C16.508 42.6918 17.1731 42.6778 17.5091 42.5798C18.1742 42.3838 18.6432 41.9497 18.9513 41.2566C19.0633 40.9906 19.0703 40.3885 19.0773 30.9304V20.8841L18.9093 20.5131C18.6852 20.023 18.1042 19.484 17.6281 19.344C17.3201 19.2529 16.522 19.2389 11.9784 19.2459C9.06607 19.2459 6.60877 19.2739 6.51076 19.3019ZM16.907 29.6002V37.7562L11.9924 37.7772L7.07083 37.7912V29.6002V21.4092L11.9854 21.4232L16.907 21.4442V29.6002ZM12.3285 39.2964C12.8045 39.5484 12.9655 40.2695 12.6505 40.7386C12.1254 41.5227 10.9913 41.1376 10.9913 40.1715C10.9913 39.4294 11.6914 38.9743 12.3285 39.2964ZM37.1045 38.7783L37.2865 38.6383C37.3915 38.5543 37.5036 38.4913 37.5386 38.4913C37.6786 38.4913 37.9866 38.9113 38.1406 39.3104C38.4557 40.1365 39.1418 40.5845 40.78 41.0466C41.9351 41.3686 42.0051 41.4106 42.0051 41.8167V42.1317H39.5548H37.1045V40.4585V38.7783Z"
      fill={color}
    />
  </svg>
);

const PortfolioResponsiveDisplays: React.FC<
  PortfolioResponsiveDisplaysProps
> = ({ ResponsiveDisplaysData = [], primaryColor = "#2C2D2C" }) => {
  return (
    <div id="responsive-design" className="py-6 md:py-12 w-full xl:w-[95%]">
      <div className="flex gap-4 border-b border-gray-400 items-center py-2 pl-2  md:pl-8">
        <ResponsiveDisplaysIcon color={primaryColor} />

        <h3 className="text-[2rem] md:text-[3rem]">RESPONSIVE DESIGN</h3>
      </div>

      <div className="flex flex-col items-center max-w-[100%] py-8 md:mx-12">
        {/* Top Container */}
        <div className="w-[100%] md:h-[600px] flex items-center justify-center">
          <img
            src={ResponsiveDisplaysData[0].content}
            alt="Desktop View"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Bottom Containers */}
        <div className="flex flex-wrap justify-center w-full">
          {/* Tablet */}
          <div className="w-full max-w-[50%]">
            <img
              src={ResponsiveDisplaysData[1].content}
              alt="Tablet View"
              className="w-full h-[80%] object-cover"
            />
          </div>

          {/* Mobile */}
          <div className="flex-1 w-full max-w-[50%]">
            <img
              src={ResponsiveDisplaysData[2].content}
              alt="Mobile View"
              className="w-full h-[80%] object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioResponsiveDisplays;
